export const environment = {
    backendUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:8080/' : "https://variotrade-backend.kfmdm.com/"//'https://backend.testsofort.de/',
}